module.exports = __webpack_public_path__ + "media/src/website/images/locations/taching/profile-259d866d683ae5391a2e4bd272318f09.jpg";